import React, { useEffect } from "react";
import './hero.scss';
import hero from './../../image/hero.png';
import { Link } from "react-router-dom";
import MagneticLink from "./magnetic-link";

const Hero: React.FC = () => {
  useEffect(() => {
    const handleScroll = (event: Event) => {
      const lastKnownScrollPosition = window.scrollY;

      if (lastKnownScrollPosition > 100) {
        document.querySelector(".scroll-down-wrap")?.classList.add("hidden");
      } else {
        document.querySelector(".scroll-down-wrap")?.classList.remove("hidden");
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className="hero container">
        <div className="wrapper">
          <img src={hero} alt="" />
          <h2>
            <span>Hello, I am Alex</span>
            <span> - </span>
            <span>Product Designer</span>
          </h2>
          <div className="description">
            <div>I enjoy creating products from scratch</div>
            <div>and improving existing ones. </div>
            <div className="spinner-wrapper">In simple terms, I design
              <div className="cube">
                  <div className="cubespinner">
                      <div className="face1">websites</div>
                      <div className="face2">mobile apps</div>
                      <div className="face3">prototypes</div>
                      <div className="face4">landing pages</div>
                  </div>
              </div>
            </div>
            <span>that make a profit or enhance business!</span>
          </div>
          <div className="hero-bottom">
            <Link to="/contact" className="cta mobile-fw">Let’s talk</Link>
            <div className="pulse-container">
              <span className="pulse-button"></span>
              <div className="open-for-opportunities">Currently working</div>
            </div>
          </div>
          
          <div className="scroll-down-wrap no-border">
            <a href="#portfolio" className="section-down-arrow ">
                <svg className="nectar-scroll-icon" viewBox="0 0 30 45" enable-background="new 0 0 30 45">
                    <path className="nectar-scroll-icon-path" fill="none" stroke="#3A87F7" stroke-width="2" stroke-miterlimit="10" d="M15,1.118c12.352,0,13.967,12.88,13.967,12.88v18.76  c0,0-1.514,11.204-13.967,11.204S0.931,32.966,0.931,32.966V14.05C0.931,14.05,2.648,1.118,15,1.118z"></path>
                </svg>
            </a>
        </div>

        </div>
      </section>
      <div>
            <MagneticLink type={"blue"}/>
            <MagneticLink type={"orange"}/>
            <MagneticLink type={"purple"}/>
          </div>
    </>
  );
};

export default Hero;
